import "react-app-polyfill/ie9";
import "core-js/es/map";
import "core-js/es/set";
import "raf/polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import ReduxPromise from "redux-promise";
import ReduxThunk from 'redux-thunk';
import reducers from "./reducers";
import './css/index.css';
import 'font-awesome/css/font-awesome.css'
import App from './components/App';
import zhCN from 'antd/lib/locale-provider/zh_CN';

// redux devtools
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, composeEnhancers(applyMiddleware(ReduxPromise, ReduxThunk)))

// 原始的store
// const createStoreWithMiddleware = applyMiddleware(ReduxPromise, ReduxThunk)(createStore);
// const store = createStoreWithMiddleware(reducers)
ReactDOM.render(
  <Provider store={store} locale={zhCN}>
    <App />
  </Provider>,
  document.getElementById('root')
);